import { IPrePanelInformation } from "@/types/PrePanelInformation.types";

export const PrePanelInformationExamples: { [key: string]: IPrePanelInformation } = {
  12345: {
    vendorId: "12345",
    skuPerformanceMetrics: [
      {
        existingProductSku: 1001,
        existingProductName: "Product A",
        retailPriceOfExistingProduct: 10.99,
        sizeOzOfExistingProduct: null,
        weeklySalesOfExistingProduct: 200,
        weeklySoldEachOfExistingProduct: 150,
        salesPerStorePerWeekOfExistingProduct: 20,
        avgUnitsSoldPerStoreOfExistingProduct: 5,
        percentChangeTyLyOfExistingProduct: 10,
        pricePerOunceOfExistingProduct: 0.69,
      },
    ],
    competitorAnalysis: [
      {
        competitorBrandRetailer: "Competitor A",
        retailPriceOfCompetitorProduct: 9.99,
        sizeOzOfCompetitorProduct: null,
        pricePerOunceOfCompetitorProduct: 0.63,
      },
    ],
    productAnalysis: {
      ideaId: "1",
      vendorAssessmentId: "",
      businessStatus: "",
      ingredientId: "",
      title: "Product A",
      categoryManagerUser: {
        id: "",
        userName: "",
        userId: "",
      },
      developer: "Developer A",
      businessCategory: "",
      productType: "",
      panelType: "",
      sellingPeriod: "",
      reasonForDevelopment: "Market demand",
      requiredAttributes: [{
        value: "",
        label: "",
      }],
      estWeeklySales: 200,
      estWeeklyUnitVol: 150,
      description: "Description of Product A",
      vendorCorporateName: "",
      retailPrice: 10.99,
      size: "500g",
      packSize: 12,
      panelDate: "",
      typeOfPackage: "",
      ingredientList: "Ingredient A, Ingredient B",
      unacceptableIngredients: "",
      retailStructure: "",
      logistics: "",
      shelfLife: "12 months",
      typeOfVendor: "",
      nutritionFactPanel: null,
      questionnaire: { PC: [], CM: [] },
      availableTransitions: null,
      countryOfOrigin: "",
      tariff: "",
      giftPack: false,
      amountOfProductsInGiftPack: null,
      productSpecification: []
    },
  },
  67890: {
    vendorId: "67890",
    skuPerformanceMetrics: [
      {
        existingProductSku: 1002,
        existingProductName: "Product B",
        retailPriceOfExistingProduct: 15.49,
        sizeOzOfExistingProduct: null,
        weeklySalesOfExistingProduct: 300,
        weeklySoldEachOfExistingProduct: 250,
        salesPerStorePerWeekOfExistingProduct: 30,
        avgUnitsSoldPerStoreOfExistingProduct: 7.5,
        percentChangeTyLyOfExistingProduct: -5,
        pricePerOunceOfExistingProduct: 0.97,
      },
    ],
    competitorAnalysis: [
      {
        competitorBrandRetailer: "Competitor B",
        retailPriceOfCompetitorProduct: 14.99,
        sizeOzOfCompetitorProduct: null,
        pricePerOunceOfCompetitorProduct: 0.94,
      },
    ],
    productAnalysis: {
      ideaId: "2",
      vendorAssessmentId: "",
      businessStatus: "",
      ingredientId: "",
      title: "Product B",
      categoryManagerUser: {
        id: "",
        userName: "",
        userId: "",
      },
      developer: "Developer B",
      businessCategory:"",
      productType: "",
      panelType: "",
      sellingPeriod: "",
      reasonForDevelopment: "New launch",
      requiredAttributes: [{
        value: "",
        label: "",
      }],
      estWeeklySales: 300,
      estWeeklyUnitVol: 250,
      description: "Description of Product B",
      vendorCorporateName: "",
      retailPrice: 15.49,
      size: "1kg",
      packSize: 6,
      panelDate: "",
      typeOfPackage: "",
      ingredientList: "Ingredient C, Ingredient D",
      unacceptableIngredients: "",
      retailStructure: "",
      logistics: "",
      shelfLife: "18 months",
      typeOfVendor: "",
      nutritionFactPanel: null,
      questionnaire: { PC: [], CM: [] },
      availableTransitions: null,
      countryOfOrigin: "",
      tariff: "",
      giftPack: false,
      amountOfProductsInGiftPack: null,
      productSpecification: []
    },
  },
};